module.exports = __webpack_public_path__ + "static/media/XIIIh.d1ce2729.png";